import { PromptAssinatura } from '../enums/EnumPromptAssinatura';

export interface ICertificadoDigital {
  senhaDoCertificadoDigital: string;
  file: File;
  assinarDocumento: PromptAssinatura
  exibirVencimentoCertificado: boolean
  nomeDoCertificadoDigital?: string
}

export default class CertificadoDigital implements ICertificadoDigital {
  senhaDoCertificadoDigital: string;

  file: File;

  assinarDocumento: PromptAssinatura;

  exibirVencimentoCertificado: boolean;

  nomeDoCertificadoDigital?: string;

  constructor() {
    this.senhaDoCertificadoDigital = '';
    this.file = null;
    this.assinarDocumento = PromptAssinatura.NaoAssinar;
    this.exibirVencimentoCertificado = false;
    this.nomeDoCertificadoDigital = '';
  }
}
